import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=5c761d67&"
import script from "./commonTable.vue?vue&type=script&lang=js&"
export * from "./commonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports